export default __webpack_public_path__ + "static/media/ellipse.af23d216.png";